import React from 'react'
import {Context as AppContext} from '../../contexts/App'
import CreateClient from './create'
import CardContent from '@mui/material/CardContent'
import Typography from '@mui/material/Typography'
import CardActions from '@mui/material/CardActions'
import Box from '@mui/material/Box'
import Card from '@mui/material/Card'
import Grid from '@mui/material/Grid'
import AddIcon from '@mui/icons-material/Add'
import EditIcon from '@mui/icons-material/Edit'
import Toolbar from '@mui/material/Toolbar'
import Tooltip from '@mui/material/Tooltip'
import IconButton from '@mui/material/IconButton'
import Stack from '@mui/material/Stack'
//import ArraCard from './Arra'

const SupplierCard = ({supplier, action, check, isSelected, ...rest}) => {
	

	return (
		<Card sx={{'margin': '15px 10px', backgroundColor:isSelected?'#ffd':'#fff'}} >
			<CardContent sx={{cursor:'pointer'}} onClick={event => action && action(supplier)}>
			<Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
				{supplier.bundle}
			</Typography>
			<Typography variant="h5" component="div">
				{supplier.name}
			</Typography>
			<Typography sx={{ mb: 1.5 }} color="text.secondary">
				{supplier.products.length} productos
			</Typography>
			</CardContent>
			<CardActions>
				<Stack sx={{minWidth:'200px', maxWidth:'400px'}}>
				{rest.children}	    		
				</Stack>
			</CardActions>
		</Card>
	)
}

const SuppliersToolbar = ({selected, create, edit, ...rest}) => {
	return (
			<Toolbar sx={{
			    pl: { sm: 2 },
			    pr: { xs: 1, sm: 1 },
				position: 'fixed',
    			background: 'white',
    			border: '1px solid #cacaca',
    			zIndex: '10',
    			borderRadius: '9px',
				right: '15px'
			  }}
			>
			  <Typography>Crear Proveedor</Typography>
			  <Tooltip title="Crear Proveedor">
			    <IconButton onClick={create}>
			      <AddIcon />
			    </IconButton>
			  </Tooltip>
		  	{selected && 
		  		<React.Fragment>
				  	<Typography>{"Editar proveedor " + selected.name}</Typography>
			  		<Tooltip title={"Editar proveedor " + selected.name}>
				  	  <IconButton onClick={edit}>
				  	    <EditIcon />
				  	  </IconButton>
				  	</Tooltip>
		  		</React.Fragment>
			  }
			</Toolbar>
	)
}

const SupplierBoard = () => {
	const app = React.useContext(AppContext)
	const { current } = app
	const { suppliers, detail } = app.suppliers
	const customContainer = React.useRef(null)
	const [open, setOpen] = React.useState(false)
	const openD = () => setOpen(true)


	return (
		<Box sx ={{
			width: "100%",
			display: "flex",
			alignItems: "baseline",
			justifyContent: "space-evenly",
			flexWrap: "wrap",
			flexDirection: "row",
			alignContent: "center",
			padding:'30px',
		}}>
			<SuppliersToolbar selected={current} create={openD} edit={openD}/>
			<Grid container sx={{mt:10}} >
				{suppliers && 
					suppliers.map(supplier => {
						let c = supplier.name
						const isSelected = current && current.name == supplier.name
						return (<Grid item><SupplierCard isSelected={isSelected} key={supplier.name} supplier={supplier} action={detail}/></Grid>)
					})
				}
			</Grid>
			<Grid container spacing={2} ref={customContainer}/>
			<CreateClient model={current} open={open} close={() => setOpen(false)}/>
		</Box>
	)

}



export default  () => {

	return (
			<Box>
				<SupplierBoard/>
			</Box>
	)
}